import Header from './components/header'
import './custom'

function isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches
}






